import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Camera, MessagesSquare, Plus, ArrowRight, Store } from "lucide-react";
import { useApi } from "@/lib/api";
import { useMe } from "@/context/Me";
import { JobCard } from "@/pages/Jobs";

export default function ClientHome() {
  const api = useApi();
  const { me } = useMe();
  const [jobs, setJobs] = useState([]);
  useEffect(() => { api.get("/jobs/mine").then((r) => setJobs(r.data)).catch(() => {}); }, [api]);
  const first = (me?.full_name || "").split(" ")[0];
  return (
    <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
      <div className="fade-up">
        <div className="eyebrow mb-1">Olá, {first}</div>
        <h1 className="text-4xl font-black uppercase sm:text-5xl">O que precisa consertar hoje?</h1>
      </div>
      <div className="mt-8 grid gap-4 md:grid-cols-3">
        <Link to="/diagnostico" data-testid="home-photo-card" className="panel panel-hover relative overflow-hidden bg-[#FFC700] p-6 text-[#111317] md:col-span-2">
          <div className="tape-thin absolute bottom-0 left-0 h-2 w-full opacity-60" />
          <Camera size={36} />
          <h2 className="mt-4 text-4xl font-black uppercase">Avaliação técnica</h2>
          <p className="mt-1 max-w-md font-medium">Envie até 3 fotos do problema e receba o diagnóstico da obra: causa, urgência, materiais e custo estimado.</p>
          <span className="mt-5 inline-flex items-center gap-2 font-bold">Começar <ArrowRight size={18} /></span>
        </Link>
        <div className="grid gap-4">
          <Link to="/assistente" data-testid="home-assistant-card" className="panel panel-hover p-5"><MessagesSquare className="text-[#FFC700]" /><h3 className="mt-2 text-2xl font-bold uppercase">Assistente Zelobra</h3><p className="text-sm text-slate-400">Tire dúvidas e calcule materiais</p></Link>
          <Link to="/chamados/novo" data-testid="home-newjob-card" className="panel panel-hover p-5"><Plus className="text-[#FF5722]" /><h3 className="mt-2 text-2xl font-bold uppercase">Novo chamado</h3><p className="text-sm text-slate-400">Descreva e receba propostas</p></Link>
          <Link to="/lojas" data-testid="home-stores-card" className="panel panel-hover p-5"><Store className="text-[#FFC700]" /><h3 className="mt-2 text-2xl font-bold uppercase">Lojas perto de você</h3><p className="text-sm text-slate-400">Materiais, ferragens e tintas pelo GPS</p></Link>
        </div>
      </div>
      <div className="mt-10 flex items-center justify-between">
        <h2 className="text-2xl font-bold uppercase">Seus chamados recentes</h2>
        <Link to="/chamados" className="text-sm font-bold text-[#FFC700]" data-testid="home-all-jobs">Ver todos</Link>
      </div>
      <div className="mt-4 grid gap-3 md:grid-cols-2">
        {jobs.slice(0, 4).map((j) => <JobCard key={j.id} j={j} />)}
        {!jobs.length && <p className="text-slate-400">Nenhum chamado ainda. Comece pela foto!</p>}
      </div>
    </div>
  );
}
